<script lang="ts">
	export let lead_time_text: string
</script>

<div>
	{lead_time_text}
</div>

<style>
	div {
		background-color: var(--dark-transparent-overlay);
		color: var(--contrast-text);
		font-size: 16px;
		padding: 4px 8px;
		font-family: 'Protipo';
	}
</style>
